import { useState } from 'react'
import { useUpdateProject } from '../api/queries'
import type { Project } from '../api/types'

/**
 * Sagens ordrenummer i Ordrestyring (beslutning 077), øverst på sagen.
 *
 * Nye sager får nummeret ved oprettelsen. Sagerne fra før feltet har ikke et, og
 * det siges højt, så de kan få det på - men det kræves ikke for at rette resten af
 * sagen. Et nummer kan rettes, ikke fjernes; serveren afviser en tom værdi.
 */
export function OrderNumberControl({ project, canEdit }: { project: Project; canEdit: boolean }) {
  const update = useUpdateProject(project.id)
  const [editing, setEditing] = useState(false)
  const [value, setValue] = useState('')
  const [error, setError] = useState<string | null>(null)

  function start() {
    setValue(project.orderNumber ?? '')
    setError(null)
    setEditing(true)
  }

  async function save(event: React.FormEvent) {
    event.preventDefault()
    setError(null)

    try {
      await update.mutateAsync({ orderNumber: value })
      setEditing(false)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ordrenummeret kunne ikke gemmes.')
    }
  }

  if (editing) {
    return (
      <form className="row" style={{ gap: 6, flexWrap: 'wrap', marginTop: 6 }} onSubmit={(e) => void save(e)}>
        <input
          aria-label="Ordrenummer"
          placeholder="F.eks. 4850-1"
          pattern="[0-9]+(-[0-9]+)*"
          title="Cifre og bindestreg, som nummeret står i Ordrestyring - f.eks. 4850-1"
          autoFocus
          required
          style={{ width: 150 }}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button className="btn btn--primary btn--sm" type="submit" disabled={update.isPending}>
          {update.isPending ? 'Gemmer ...' : 'Gem'}
        </button>
        <button className="btn btn--sm" type="button" onClick={() => setEditing(false)}>
          Fortryd
        </button>
        {error && <span className="tiny warn">{error}</span>}
      </form>
    )
  }

  return (
    <div className="row" style={{ gap: 8, marginTop: 4, flexWrap: 'wrap' }}>
      {project.orderNumber ? (
        <span className="small muted">Ordre {project.orderNumber}</span>
      ) : (
        <span className="small" style={{ color: '#B45309' }}>
          Mangler ordrenummer fra Ordrestyring
        </span>
      )}
      {canEdit && (
        <button className="btn btn--sm" type="button" onClick={start}>
          {project.orderNumber ? 'Ret' : 'Tilføj'}
        </button>
      )}
    </div>
  )
}
